module.exports = __webpack_public_path__ + "img/double arrow.ee496e7c.svg";